/** Cancellation eligibility helpers (mirror backend rules). */

export function canCancelBooking(booking) {
  if (!booking) return false;
  if (booking.service_started_at || booking.start_otp_verified_at || booking.phone_contacted_at) return false;
  const status = booking.status;
  if (status === 'cancelled' || status === 'completed') return false;
  return true;
}

export function cancellationPhase(booking) {
  if (!canCancelBooking(booking)) return 'blocked';
  const travel = booking.travel_status;
  if (booking.status === 'payment_pending' || travel === 'not_started') return 'no_charge';
  if (travel === 'en_route' || travel === 'arrived') return 'travel_charge';
  return 'no_charge';
}
